import { useEffect, useState } from "react";
import { useGetTournamentLeagueRewardsQuery } from "../../apis/tournaments.api";
import { GameCategory, PlayerItem } from "../../models/User";
import { GainCoinComponent } from "../ui/gain-coin.component";
import RankReward from "./rank-reward.component";
import RankStatus from "./rank-status.component";
import { computeRewardVisibleIcons, flattenRewardsByRank } from "../../utils/RewardsUtils";
import { useNavigate } from "react-router-dom";

interface StickyPlayerRankProps {
  player: PlayerItem
}

const StickyPlayerRank: React.FC<StickyPlayerRankProps> = ({player}) => {

  // console.log("sticky player : ", player);

  // get player.league and player.leagueRank >> get tournamentRewardsForLeague
  // then extract rewardList for player leagueRank
  // then display icon according to rewardList

  const [leagueRewardsIcons, setLeagueRewardsIcons] = useState([] as any);
  const isRanked = player.tournamentNumber !== -1;
  const {data: leagueRewardsData, isLoading: areLeagueRewardsLoading} = useGetTournamentLeagueRewardsQuery({league: player.league});
  const navigate = useNavigate();

  useEffect(() => {
    if(leagueRewardsData){
      const flattenedRewards = flattenRewardsByRank(leagueRewardsData);
      setLeagueRewardsIcons( computeRewardVisibleIcons(flattenedRewards[Number(player.leagueRank)]));
    }
  }, [leagueRewardsData]);

  const handleClick = () => {

    switch (player.gameCategory) {
      case GameCategory.INVEST_GAME:
        navigate('/portfolio');
        break;
      case GameCategory.BET_GAME:
        navigate('/tournament/current');
        break;
      default:
        navigate(-1);
        break;
    }

  }

  return (
    <>
      <div className="w-full max-w-md pl-2 pr-4 py-3 bg-black rounded-lg justify-start items-center gap-3 inline-flex cursor-pointer">

        <div className="justify-start items-center flex gap-1">

          { isRanked &&
            <RankStatus rank={Number(player.leagueRank)} status={player.leagueStatus} dark={true}/>
          }

          <div className="p-0.5 bg-white rounded shadow border border-neutral-200 justify-start items-start gap-4 flex">
            <img className="w-7 h-7 rounded-sm" src={player.avatarUrl || `${process.env.REACT_APP_STATIC_ASSETS}/favicon.svg`}/>
          </div>

          { isRanked &&
            <RankReward icons={leagueRewardsIcons} darkMode={true}/>
          }

        </div>

        <div className="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
          <div className="self-stretch text-white text-sm font-bold font-['Satoshi']">
            {player.pseudo}
          </div>
        </div>

          <div className="flex-col justify-start items-end gap-0.5 inline-flex">
            {isRanked &&
            <div className="justify-start items-center gap-0.5 inline-flex">
              <div className="w-3 h-3 relative"/>
              <div className="text-white text-lg font-bold font-['Satoshi'] leading-[17px]">
                {/* <QuantityCoinComponent size={14} quantity={ player.score || 0}/> */}
                <GainCoinComponent gain={player.score || 0} size={14}/>
              </div>
            </div>
            }
            {!isRanked &&
              <div className="items-center gap-0.5 inline-flex">
                <button className="primary" onClick={handleClick}>Play</button>
              </div>
            }

            {/* <div className={classNames("text-green-500 text-[10px] font-bold font-['Satoshi'] leading-[10px]", overallPerfLoading || week === 'previous' ? 'hidden' : '')}> */}
            {/* <div className={classNames("text-green-500 text-[10px] font-bold font-['Satoshi'] leading-[10px]")}> */}
              {/* <GainCoinComponent gain={(overallPerf || 0)}/> */}
              {/* <GainCoinComponent gain={player.score} size={0} /> */}
            {/* </div> */}
          </div>

      </div>
      { isRanked &&
        <div className="w-full max-w-md flex flex-row items-center justify-between px-2">

          <div className="flex flex-row items-center gap-1">
            <div className="w-4 h-4 rounded-xl bg-victory-green"></div>
            <p>Qualification</p>
          </div>

          <div className="flex flex-row items-center gap-1">
            <div className="w-4 h-4 rounded-xl border border-dashed border-victory-green"></div>
            <p>In progress</p>
          </div>

          <div className="flex flex-row items-center gap-1">
            <div className="w-4 h-4 rounded-xl bg-red-500"></div>
            <p>Relegation</p>
          </div>

        </div>
      }

    </>
  );
}

export default StickyPlayerRank;